import {Injectable} from '@angular/core';
import {Sort} from '@angular/material/sort';
import {ActivatedRoute, Router} from '@angular/router';
import {MxGridCustomizerEvent, MxGridProps} from './mx-grid-customizer-event';

export class Page {
    pageIndex: number;
    length: number;
    pageSize: number;
}

export class SessionGridData {
    sort?: Sort;
    filter?: any;
    columns?: string[];
    page?: Page;
}

export interface GridConfigStorageService {
    saveSort(sort: Sort): void;
    getSortData(): Sort;
    saveFilter(filter: any): void;
    getFilterData(): any;
    saveColumns(columns: string[]): void;
    getColumnsData(): Set<string>;
    savePage(page: Page): void;
    getPageData(): Page;
    updateKey(key: string): void;
}

@Injectable()
export class MxGridConfigStorageService implements GridConfigStorageService {
    private saveEnabled: boolean = true;
    private key: string;

    constructor(private route: ActivatedRoute,
                private router: Router) {
    }

    public setUp(event: MxGridCustomizerEvent): void {
        let gridProps: MxGridProps = event.gridProps;
        this.saveEnabled = gridProps.saveGridState;
        this.key = gridProps.gridId;
        let sortData = this.getSortData();
        if (sortData) {
            event.customizeProps({
                sortActive: sortData.active,
                sortDirection: sortData.direction
            });
        }
        let pageData = this.getPageData();
        if (pageData) {
            event.customizeProps({
                paginationLimit: pageData.pageSize,
                pageIndex: pageData.pageIndex
            });
        }
    }

    saveSort(sort: Sort): void {
        this.updateState(() => {
            return {sort: sort};
        });
    }

    getSortData(): Sort {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            if (gridData && gridData.sort) {
                return gridData.sort;
            }
        }
        return null;
    }

    saveFilter(filter: any): void {
        this.updateState(() => {
            this.router.navigate(
                [],
                {
                    relativeTo: this.route,
                    queryParams: filter,
                });
            return {filter: filter};
        });
    }

    getFilterData(): any {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            if (gridData && gridData.filter) {
                return gridData.filter;
            }
        }
        return null;
    }

    saveColumns(columns: string[]): void {
        this.updateState(() => {
            return {columns};
        });
    }

    getColumnsData(): Set<string> {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            if (gridData && gridData.columns && gridData.columns instanceof Array) {
                return new Set(gridData.columns);
            }
        }
        return null;
    }

    private updateState(columns: () => SessionGridData): void  {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            gridData = {...gridData, ...columns.apply(gridData)};
            const data = JSON.stringify(gridData);
            sessionStorage.setItem(this.key, data);
        }
    }

    savePage(page: Page): void {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            gridData = {...gridData, page: page};
            const data = JSON.stringify(gridData);
            sessionStorage.setItem(this.key, data);
        }
    }

    getPageData(): Page {
        if (this.key && this.saveEnabled) {
            let gridData = JSON.parse(sessionStorage.getItem(this.key)) as SessionGridData;
            if (gridData && gridData.page) {
                return gridData.page;
            }
        }
        return null;
    }

    updateKey(key: string): void {
        this.key = key;
    }

}
